export default __webpack_public_path__ + "static/media/digital-brain-logo.8adeac93.svg";